var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-modal-setting',{attrs:{"title":"Custom Width","value":_vm.valueText,"placeholder":"Default"}},[_c('core-input-textbox',{attrs:{"autofocus":true,"maxlength":"3","placeholder":"Enter pixel width"},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }